<shared-chat *ngIf="chat" class="chats-body-zonachat chat-without-header"
    [value]="chat" [ownerUserId]="ownerUserId" [ownerUserType]="ownerUserType">
</shared-chat>